<!-- app/components/Header/Right/UserMenu.vue -->
<template>
    <UDropdownMenu :items="menuItems" data-region="usermenu" :modal="false" :content="{ align: 'end', side: 'bottom'}"
                   :ui="{content: 'p-1 min-w-58', item: 'p-3 border-gray-200'}">
      <UButton type="button" :avatar="{src: userStore.avatar}" icon="ph:caret-down-bold" trailing
               class="gap-0 p-0 rounded-full bg-transparent hover:bg-transparent hover:cursor-pointer
                                    transition-transform active:bg-transparent focus:outline-none group btn-rotate-icon-click"
               :ui="{ leadingAvatar: 'size-9', trailingIcon: [iconClass, 'size-4 p-0 ml-1 inline-block']}">
      </UButton>
    </UDropdownMenu>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { DropdownMenuItem } from '@nuxt/ui'
const uiStore = useUiStore()

defineProps({
  iconClass: {
    type: String,
    default: 'text-gray-700'
  }
})

const userStore = useUserStore()

const makeExit = () => {
  // Coleta a sesskey priorizando o userStore. Se for falsa/vazia, tenta o uiStore.
  const currentSesskey = userStore.sesskey || uiStore.sesskey;

  // Limpa os rastros do Nuxt (Pinia + Cookies)
  userStore.clearUser();

  // Navega para o Moodle usando a função nativa correta com 'i'
  navigateTo(`/login/logout.php?sesskey=${currentSesskey}`, { external: true });
}

const menuItems = ref<DropdownMenuItem[]>([
  {label: 'Perfil', to: '/user/profile.php', external: true},
  {label: 'Notas', to: '/grade/report/overview/index.php', external: true},
  {label: 'Calendário', to: '/calendar/view.php?view=month', external: true},
  {label: 'Meus Cursos', to: '/my/courses.php', external: true, class: 'border-b'},
  {label: 'Preferências', to: '/user/preferences.php', external: true},
  {label: 'Sair', onSelect: makeExit}
])

</script>